
import React from 'react'
import styled from 'styled-components'
import mobileappimage from '../assets/App Development BG_upscayl_4x_remacri 1.png'
import bannermobile from '../assets/Mobile.png'
import contimgaemobile from '../assets/BG.png'
import contimageup from '../assets/Arm App.png'
import serviceImage from '../assets/image 67.png';
import serviceImage1 from '../assets/image 68.png';
import serviceImage2 from '../assets/image 69.png';
import serviceImage3 from '../assets/Group 158.png';
import imageuiux from '../assets/Map.png'
import Rectangle111 from '../assets/MobApp1.png'
import Rectangle112 from '../assets/Rectangle 113 (1).png'
import Rectangle113 from '../assets/Rectangle 112 (2).png'
import Rectangle114 from '../assets/Rectangle 114 (2).png'
import Rectangle115 from '../assets/Rectangle 119 (2).png'
import Rectangle116 from '../assets/Rectangle 115 (1).png'
import Rectangle117 from '../assets/Rectangle 116 (2).png'
import Rectangle118 from '../assets/Rectangle 117 (2).png'
import Rectangle119 from '../assets/Rectangle 118 (1).png'
import Rectangle120 from '../assets/Apptoolsimg.png'
import Rectangle121 from '../assets/Apptoolsimg.png'
import Rectangle001 from '../assets/Tech1.png'
import Rectangle002 from '../assets/Tech2.png'
import Rectangle003 from '../assets/Tech3.png'
import Rectangle004 from '../assets/Tech4.png'
import Rectangle005 from '../assets/Tech5.png'
import Rectangle006 from '../assets/Tech6.png'
import Rectangle007 from '../assets/Tech7.png'
import Rectangle008 from '../assets/Tech8.png'
import Rectangle009 from '../assets/Tech9.png'
import Rectangle010 from '../assets/Tech10.png'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom';

const MainWrapContanier = styled.div``
const MobileAppImage = styled.img`
position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  object-fit: cover;
  z-index: -1;
@media (max-width:600px){
  width:100%;
  height:auto;
}
@media (min-width:601px) and (max-width:1024px){
  width:100%;
  height:auto;
}
`
const Wrap = styled.div`
width:100%;
height:100%;
padding: 0%;
margin: 0%;
box-sizing:border-box;
  /* background-color: red; */
`


// const FrontHead = styled.h1`
//   position: absolute;
//   top: 300px;
//   color: white;
//   text-align: center;
//   font-size: 79px;
//   left: 100px;
//   z-index: 100;
//   text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7); /* Adding shadow effect */
  
//   @media (max-width: 600px) {
//     font-size: 20px;
//     top: 100px;
//   }

//   @media (min-width: 601px) and (max-width: 1024px) {
//     font-size: 25px;
//     top: 100px;
//   }

//   @media (min-width: 1441px) and (max-width: 2100px) {
//     top: 350px;
//     left: 400px;
//   }
// `;
const MobileHead = styled.h1`
  font-size: 70px;
  color:white;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7); /* Adding shadow effect */
  @media (max-width:600px) {
  font-size:25px;
}
@media (min-width:601px) and (max-width:1024px){
  font-size:40px;
}
@media (min-width:1441px) and (max-width:2200px){
  font-size:110px;
}
`

const MobileHeadPara = styled.p`
color:white;
margin-top:20px;
text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7); /* Adding shadow effect */
@media (max-width:600px) {
  font-size:10px;
}
@media (min-width:601px) and (max-width:1024px){
  font-size:15px;
}
`
const Div = styled.div`
position: absolute;
z-index: 100;
/* background-color: red; */
top: 200px;
left: 110px;
@media (max-width:600px) {
  top:120px;
  left: 20px;
}
@media (min-width:601px) and (max-width:1024px){
  top:160px;
  left: 70px;
}
@media (min-width:1441px) and (max-width:2200px){
  top:260px;
  left: 100px;
}
`
const ContanierHead = styled.div`
  width:100%;
  height:500px;
  /* background-color: red; */
  display:flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  box-sizing:border-box;
  padding:50px;
  /* padding-left:150px; */
  gap: 40px;
  @media (max-width:600px) {
    width:100%;
    height: auto;
    flex-direction: column;
    padding:10px;
  }
  @media (max-width:600px) {
    
    flex-direction: column-reverse;
    
  }

  @media (min-width:601px) and (max-width:1024px){
    width:100%;
    height: auto;
    flex-direction: column;
    padding:10px;
}
@media (min-width:601px) and (max-width:1024px){
  flex-direction: column-reverse;
}
@media (min-width:1025px) and (max-width:1300px){
  gap:0px
}
@media (min-width:1301px) and (max-width:1440px){
  height:550px;
}
@media (min-width:1441px) and (max-width:2100px){
  height:600px;
}
`
const ContanierRhtHead = styled.h1`
  width: 45%;
  height: 400px;
  /* background-color: yellow; */
  font-size: 60px;
  text-align: center;
  align-items: center;
  padding-top: 100px;
  justify-content: center;
  @media (max-width:600px) {
    width:100%;
    height: auto;
    font-size: 40px;
    padding-top: 20px;
    padding-bottom:20px;
  }
  @media (min-width:601px) and (max-width:1024px){
    width:100%;
    height: auto;
    font-size: 60px;
    padding-top: 20px;
    padding-bottom:20px;
}
@media (min-width:1025px) and (max-width:1300px){
    width:100%;
    height: auto;
    font-size: 60px;
    padding-top: 20px;
    padding-bottom:20px;
}
@media (min-width:1301px) and (max-width:1440px){
    
    height: 500px;
    
}
@media (min-width:1441px) and (max-width:2100px){
  height:550px;
}
`
const ContanierMobile = styled.div`
  width:40%;
  align-items: center;
  justify-content: center;
  height:400px;
  /* background-color: blue; */
  @media (max-width:600px) {
    width:100%;
    height: auto;
    /* padding-right: 60px; */
  }
  @media (min-width:601px) and (max-width:1024px){
    width:80%;
    height: auto;
    /* padding-right: 60px; */
}
@media (min-width:1025px) and (max-width:1300px){
  width:70%;
  height: auto;
}
@media (min-width:1301px) and (max-width:1440px){
    
    height: 500px;
    
}
@media (min-width:1441px) and (max-width:2100px){
  height:550px;
}
`
const MobilePara = styled.p`
font-size: 20px;
margin-top:20px;
color:green;
`
const MobileImage = styled.img`
width:70%;
height:400px;
margin-left: 60px;
@media screen and (max-width:600px) {
  width: 50%;
  height: auto;
  margin-left: 0px;
}
@media screen and (min-width: 601px) and (max-width:1024px) {
  width: 70%;
  height: auto;
  margin-left: 0px;
}
@media (min-width:1301px) and (max-width:1440px){
    
    height: 480px;
    
}
@media (min-width:1441px) and (max-width:2100px){
  width: 60%;
  height:540px;
  margin-left:10px;
}
`
const ContanierMainMobile = styled.div`
  width:100%;
  height:570px;
  box-sizing: border-box;
  position: relative;
  /* background-color: green; */

  @media (max-width:600px){
    flex-direction: column;
    width:100%;
    height:auto;
  }
  @media (min-width:601px) and (max-width:1024px){
    flex-direction: column;
    width:100%;
    height:auto;
    
}
@media (min-width:1441px) and (max-width:2100px){
  width:100%;
  height:670px;
}
`
const ContMobImage = styled.img`
width:95%;
height:570px;
margin-left: 35px;
 @media (max-width:600px){
    flex-direction: column;
    width:100%;
    height:1100px;
    margin-left:0px;
  }
  @media (min-width:601px) and (max-width:814px){
    flex-direction: column;
    width:100%;
    height:1300px;
    margin-left:0px;
}
@media (min-width:815px) and (max-width:1024px){
  flex-direction: column;
    width:100%;
    height:1420px;
    margin-left:0px;
}
@media (min-width:1441px) and (max-width:2100px){
  width:95%;
  height:670px;
  margin-left: 45px;
}
`
const ImageTappTAG = styled.div`

width:60%;
box-sizing: border-box;
align-content: center;
text-align: center;
justify-content: center;
height:530px;
/* background-color:blue; */
margin-bottom:40px;

@media (max-width:600px) {
width: 100%;
height: auto;
}
@media (min-width:601px) and (max-width:1024px){
  width: 100%;
  height: auto;
  margin-bottom:20px;

}
@media (min-width:1301px) and (max-width:1440px){
  width: 48%;
  height: auto;
  margin-bottom:20px;

}
@media (min-width:1441px) and (max-width:2100px){
  width:40%;
  height:auto;
}
`
const ContMobImage1 = styled.img`
width:58%;
height:auto;
align-content: center;
justify-content: center;
@media (min-width:1025px) and (max-width:1300px){
  width:63%;
}
`
const MobileHeading = styled.h1`
 text-align: center;
 align-items: center;
color:white;
font-size: 60px;
@media (max-width:600px) {
font-size: 35px;
margin-top:15px;
}
@media (min-width:601px) and (max-width:1024px){
  width: 100%;
  height: auto;
}
@media (min-width:1025px) and (max-width:1300px){
  font-size: 40px;
  margin-top: 20px;
}

@media (min-width: 1442px) and (max-width:2100px)
{
  color: #eca012;
}
`;

const CreationMain = styled.div`
  position: absolute;
  width:95%;
  box-sizing:border-box;
  flex-direction:center;
  align-items: center;
  justify-content:center;
  height:550px;
  padding:20px;
  display:flex;
z-index: 100;
top: 10px;
left:20px;
/* background-color: red; */

@media (max-width:600px) {
width: 100%;
height:auto;
flex-direction:column;
left:0px;

}
@media (min-width:601px) and (max-width:1024px){
  width: 100%;
height:auto;
flex-direction:column;
left:0px;
}
@media (min-width:1441px) and (max-width:2100px){
  width:95%;
  height:650px;
}
`
const AllContanier = styled.div`

  width:60%;
  height:550px;
  box-sizing:border-box;
padding-top:40px;

/* background-color: #464343; */
@media (max-width:600px) {
width: 100%;
height:auto;
flex-direction:column;
padding-top:0px;
align-items: center;
text-align: center;
justify-content: center;
}
@media (min-width:601px) and (max-width:1024px){
  width: 100%;
height:auto;
flex-direction:column;
padding-top:0px;
align-items: center;
text-align: center;
justify-content: center;
}
@media (min-width: 1442px) and (max-width:2100px)
{
  align-items: center;
  justify-content: center;
  text-align: center;
}
`;


const CreationHead = styled.h1`
text-align: center;
color:white;
font-size: 40px;
@media (max-width:600px) {
font-size: 27px;
}
@media (min-width:1025px) and (max-width:1300px){
  font-size: 25px;
}
`
const CreationPara = styled.p`
color:white;
margin-top: 20px;
line-height: 35px;
font-size: 25px;
@media (max-width:600px) {
/* color: red; */
align-item:center;
text-align: center;
line-height: 43px;
font-size: 15px;
}
@media (min-width:1025px) and (max-width:1300px){
  font-size: 18px;
}
@media (min-width:1441px) and (max-width:2100px){
  line-height: 48px;
  text-align: center;
  align-items: center;
  
}
`
const CreationButton = styled.button`
  width: 150px;
  height: 50px;
  border: solid 1px white; /* White border */
  font-weight: bold;
  box-sizing: border-box ;
  border-radius: 50px;
  font-size: 15px;
  margin-top: 20px;
  cursor: pointer;
  
  

  color: #faf8f8; /* White text color */
  background-color:  rgba(0, 0, 0, 0.2); /* Text shadow for better readability */

  &:hover {
    opacity: 1; /* Full opacity on hover */
  }
  @media (max-width:600px) {
/* color: red; */
align-items: center;
text-align: center;
justify-content:center;

}
@media (min-width: 1442px) and (max-width:2100px)
{
  align-items: center;
  justify-content: center;
  text-align: center;
}
`;

const Container19 = styled.div`
/* background-color: yellow; */
  position: relative;
  margin-top: 10px;
  width: 100%;
  
  align-items: center;
  z-index: 1;
  box-sizing: border-box;
  height: 100%;
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;

  @media screen and (max-width:600px){
    width:100%;
    max-width:99%;
    height: auto;
    height: 2250px;
  }
  @media (min-width:601px) and (max-width:814px){
  width:100%;
    max-width:99%;
    height: auto;
    height: 1250px;
}
@media (min-width:815px) and (max-width:1024px){
  width:100%;
    max-width:99%;
    height: auto;
    height: 810px;
}
@media (min-width:1025px) and (max-width:1300px){
  width:100%;
    max-width:99%;
    height: auto;
    height: 810px;
}
@media (min-width:1301px) and (max-width:1440px){
  width:100%;
    max-width:99%;
    height: auto;
    height: 810px;
}
@media (min-width:1441px) and (max-width:2100px){
  width:100%;
  height:450px;
}
`;

const Div3 = styled.div`
width:100%;
height:auto;
  position: relative;
  background-color:green;
  align-items: center;
  justify-content: center;
  align-items: center;
  @media screen and (max-width:600px){
    width:100%;
    height: auto;
    
  }
`;
const PageContainer2 = styled.div`
  position: relative;
  width: 80%;
  height: 830px;
  z-index: 100;
  background-color: red;
  margin-left: 140px;
  
    @media screen and (max-width:600px){
      flex-direction: column;
    width:100%;
    height: auto;
  }
  
`;
const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
  align-items: center;
  position: absolute;
  top: 3%;
  /* left: 10%; */
  box-sizing: border-box;
  z-index: 1;
  width: 100%;
  
  /* background-color: #0084ff; */
  @media screen and (max-width:600px){
      flex-direction: column;
    width:100%;
    height: auto;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  @media (min-width: 1301px) and (max-width:1440px) {
    gap: 4rem;
  }
`;
const Card = styled.div`
  position: relative;
  background-color: white;
  color: black;
  width: 250px;
  height: 350px;
  padding: 1rem;
  border-radius: 25px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  text-align: center;
  opacity: 0.8;             
  border: 1px solid black;
  
  transition: transform 0.3s ease, box-shadow 0.3s ease, opacity 0.3s ease;

  &:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    opacity: 1;
   cursor: pointer;
   border: solid 2px #1c1c7a;
    background-color:  #b6b2b2; /* Background color on hover */
    transform: scale(1.05); 
  }

  &:hover img {
     /* Change image color to grayscale on hover */
    
  }

  &:hover h3 {
    color:#1c1c7a; 
  }

  &:hover p {
    color:#1c1c7a;
  }
  @media screen and (max-width:600px){
    width: 300px;
    height: 400px;
    margin-right:10px;
    
    
    /* margin-left: 20px;
    margin-right:20px; */

  }
  
`;
const CardDescription = styled.p`
  font-size: 1rem;
  color: black;

  @media screen and (max-width:600px) {
    align-item:center;
text-align: center;
line-height: 33px;
font-size: 15px;
    
  }
`;
const CardTitle = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
  @media screen and (max-width:600px) {
    font-size: 25px;
    align-items: center;
    text-align: center;
  }
`;
const CardImage = styled.img`
  width: auto;
  height: auto;
  object-fit: cover;
  margin-bottom: 1rem;
  color: black;
`;
const HeaderWeb = styled.h1`
  color: black;
  margin-top: 30px;
  font-size: 45px;
  margin-bottom: 1rem;
  box-sizing: border-box;
  justify-content: center;
  text-align: center;
  @media screen and (max-width:600px) {
    margin-left: 0%;
    margin-top: 0px;
    font-size: 16px;
  }
  @media (min-width:601px) and (max-width:1024px){
 margin-left: 0%;
    margin-top: 0px;
    font-size: 24px;
}
@media (min-width:1441px) and (max-width:2100px){
  margin-left: 100px;
  margin-right: 100px;
}
`;
const Container20 = styled.div`
box-sizing: border-box;
width: 100%;
height:100%;
align-items: center;
text-align: center;
justify-content: center;
/* background-color: red; */
@media (min-width:1025px) and (max-width:1300px){
  
    width: 100%;
    height:auto;
    
}
`
const ImageUiUx = styled.img`
  width:100%;
  align-items: center;
  height:auto;
  padding-left: 60px;
  padding-right:60px;
  object-fit: cover;
  margin-top:20px;
  
  justify-content: center;
  @media screen and (max-width:600px) {
    margin: 0%;
    width: 100%;
    height:auto;
   
    margin-top:30px;
    margin-bottom:30px;
  }
  @media (min-width:601px) and (max-width:1024px){
  margin: 0%;
    width: 100%;
    height:auto;
    margin-top:30px;
    margin-bottom:30px;
}
@media (min-width:601px) and (max-width:1024px){
  margin: 0%;
    width: 100%;
    height:auto;
    margin-top:30px;
    margin-bottom:30px;
}
@media (min-width:1301px) and (max-width:1440px){
  width:100%;
  align-items: center;
  height:auto;
  object-fit: cover;
}
@media (min-width:1441px) and (max-width:2100px){
  width:100%;
  height:auto;
}

`
const PeraWeb = styled.p`
  color: black;
  margin-top: 10px;
  font-size: 25px;
  margin-bottom: 1rem;
  text-align: center;
  box-sizing: border-box;
  align-items: center;
  
  @media (max-width:600px) {
    margin-left: 0%;
    align-item:center;
text-align: center;
line-height: 25px;
font-size: 14px;
margin:10px;
    
  }
   @media (min-width:601px) and (max-width:1024px){
 margin-left: 0%;
    align-item:center;
    font-size: 16px;
text-align: center;

margin:10px;
}
`;
const Container21 = styled.div`
  width: 100%;
 
  height:700px;
  box-sizing: border-box;
  /* background-color:green; */
  justify-content: center;
  align-items: center;
  @media (max-width:600px) {
    width: 100%;
    height:auto;
  }
   @media (min-width:601px) and (max-width:1024px){
  width: 100%;
    height:auto;
}
@media (min-width:1025px) and (max-width:1300px){
  width: 100%;
    height:800px;
}
`
const TabNavigation = styled.div`
margin-top:40px;
  width:90%;
  height:480px;
  align-items: center;
  text-align:center;
  justify-content:center;
  background-color: #d4d4d4;
  margin-left: 60px;
  @media (max-width:600px) {
    width: 100%;
    height:auto;
    
    margin-left: 0%;
  }
  @media (min-width:601px) and (max-width:1024px){
  width: 100%;
    height:auto;
    
    margin-left: 0%;
}
@media (min-width:1441px) and (max-width:2100px){
  
  align-items: center;
  text-align:center;
  justify-content:center;
    margin-left:80px;
}

`

const Dflex = styled.ul`
display: flex;
text-decoration: none;
gap:2px;
/* display: none; */
list-style-type: none;
text-align: center;
align-items: center;
padding:3px;
margin-left:5px;
@media (max-width:600px) {
   margin-left: 0px;
  }
  @media (min-width:601px) and (max-width:1024px){
  
    
    margin-left: 0%;
}
`
const FlexFill = styled.li`
text-decoration: none;
background-color: ${props => (props.active ? '#0c0ce7' : 'white')};
color:${(props => (props.active ? 'white' : 'black'))};
/* border: 1px solid black; */
width: 50%;
height: 50px;
/* color:white; */
text-align: center;
align-items: center;
padding-top:10px;
font-size: 25px;
font-weight: bold;
cursor: pointer;
border-radius: 5px;
/* display: none; */
@media (max-width:600px) {
   margin-left: 0px;
  }


`
const FlexFill1 = styled.li`
text-decoration: none;
background-color: ${props => (props.active ? '#0c0ce7' : 'white')};
color:${(props => (props.active ? 'white' : 'black'))};
/* border: 1px solid black; */
width: 50%;
height: 50px;
/* color:white; */
text-align: center;
align-items: center;
padding-top:10px;
font-size: 25px;
font-weight: bold;
cursor: pointer;
border-radius: 5px;
/* display: none; */
@media (max-width:600px) {
   margin-left: 0px;
  }


`
const TabContents = styled.div`
/* background-color:pink; */
justify-content: center;
align-items: center;
text-align: center;
width: 100%;
  height:auto;
display: ${props => (props.show ? 'block' : 'none')};
@media (max-width:600px){
  width: 100%;
  height:auto;
  
  
}
@media (min-width:601px) and (max-width:1024px){
  
   
  align-items: center;
  text-align: center;
  justify-content: center;
    width: 100%;
  height:auto;
}
@media (min-width:1025px) and (max-width:1300px){
  flex-direction: flex;
width: 100%;
  height: auto;
  align-items: center;
  text-align: center;
  justify-content: center;
}

`
const TabContents1 = styled.div`

display: ${props => (props.show ? 'block' : 'none')};
`


const HeadTab1 = styled.h1`
font-size: 15px;
`
/* const ParaTab1 = styled.p`` */
/* const ShowConten = styled.div`` */
const CardTools = styled.div`
  width: 150px;
  height: 150px;
  background-color: white;
  margin: 10px;
  margin-left: 70px;
  align-items: center;
  text-align: center;
  margin-top: 40px;
  border-radius: 20px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Added transition for smooth effect */

  &:hover {
    transform: scale(1.05); /* Scale up slightly on hover */
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2); /* Darker shadow on hover */
  }
`;

const CardTools1 = styled.div`
  width:150px;
  height:150px;
  background-color:white;
  margin:10px;
  /* margin-left: 70px; */
  align-items: center;
  text-align: center;
  margin-top: 40px;
  border-radius: 20px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Added transition for smooth effect */

&:hover {
  transform: scale(1.05); /* Scale up slightly on hover */
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2); /* Darker shadow on hover */
}

@media (max-width:600px){
  margin:0%;
  margin:20px;
  align-items: center;
  text-align: center;
  justify-content: center;
}
@media (min-width:601px) and (max-width:1024px){
  
   
 margin:0%;
  margin:20px;
  align-items: center;
  text-align: center;
  justify-content: center;
}
@media (min-width:1441px) and (max-width:2100px){
  
   
  margin:0%;
   margin:25px;
   align-items: center;
   text-align: center;
   justify-content: center;
 }
`;
const TechImage = styled.img`
width: 100px;
height:100px;
margin-top:25px;
align-items: center;
`
const TechImage1 = styled.img`

margin-top:10px;
align-items: center;
`
const Div2 = styled.div`
  width: 100%;
  align-items: center;
  text-align: center;
  justify-content: center;
  /* background-color: yellow; */
  height: auto;
  box-sizing: border-box;
  flex-wrap: wrap;
display: flex;
@media (max-width:600px) {
flex-direction: flex;
width: 100%;
  height: auto;
  align-items: center;
  text-align: center;
  justify-content: center;
}
@media (min-width:601px) and (max-width:1024px){
  flex-direction: flex;
width: 100%;
  height: auto;
  align-items: center;
  text-align: center;
  justify-content: center;
}
@media (min-width:1025px) and (max-width:1300px){
  flex-direction: flex;
width: 100%;
  height: auto;
  align-items: center;
  text-align: center;
  justify-content: center;
}
@media (min-width:1441px) and (max-width:2100px){
  
width: 100%;
  height: auto;
  align-items: center;
  text-align: center;
  justify-content: center;
}

`;
const Div0 = styled.div`
  width: 50%;
  height: auto;
  background-color: red;
display: flex;
@media (max-width:600px) {
flex-direction: column;
width: 50%;
  height: auto;
 
}


`;

const DisButton = styled.button`
  border: none;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding: 20px;
  font-size: 18px;
  font-weight: bold;
  border-radius: 50px;
  cursor: pointer;
  margin-top: 30px;
  /* margin-left: 20px; */
  background-color: #2020cf;
  color:white
`
const Div55 = styled.div`
position: absolute;
top:10px;
left:10px;
width:100%;
height: auto;
background-color: blue;
z-index:99999;

@media (max-width:600px) {
flex-direction: column;
}
`

const MobileAppDev = () => {
  const navigation = useNavigate();
  const [expanded, setExpanded] = useState(false);

  const toggleReadMore = () => {
    setExpanded(!expanded);
  };
  const [toggle, setToggle] = useState(1)

  function updateToggle(id) {
    setToggle(id)
  }
  const cards = [
    { title: 'Mobile App UI/UX Design', description: 'Build a flawless user interface for your mobile users to provide a seamless experience on their phone screens.Big Heap Tech design mobile apps according to iOS and Android conventions', img: serviceImage },
    { title: 'Web UI/UX Design', description: 'Simplify your technically complex products in cahoots with Big Heap Tech UI/UX development services to grow web traffic through modern design aesthetic and dynamic features.', img: serviceImage1 },
    { title: 'UI/UX Design Brand Identity', description: 'Drive brand growth with thorughly researched visual designs for your brand. CTA, ICON, color scheme, or typography - Big Heap Tech is an ideal umbrella term for them', img: serviceImage2 },
    { title: 'HCI Design', description: 'Maximize operational efficency and improve productivity through Big Heap Tech research, interviews and persona development to deliver user- friendly HCI designs', img: serviceImage3 },
    { title: 'HCI Design', description: 'Maximize operational efficency and improve productivity through Big Heap Tech research, interviews and persona development to deliver user- friendly HCI designs', img: serviceImage3 },

  ];
  return (
    <>
      <Wrap>
        <MainWrapContanier>

          <MobileAppImage src={mobileappimage} alt='Background' />

          <Div>
            <MobileHead data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1500">Mobile App<br></br> Development</MobileHead>
            <MobileHeadPara data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1500"> -Bringing your ideas to reality-</MobileHeadPara>
          </Div>


          <ContanierHead>

            <ContanierRhtHead data-aos="fade-right" >
              We Love Building <br></br> Awesome App!
              <MobilePara data-aos="fade-right">View Work</MobilePara>
              <DisButton onClick={() => navigation("/ContactUs")} data-aos="fade-right">Discus Your Project</DisButton>
            </ContanierRhtHead>

            <ContanierMobile>

              <MobileImage  data-aos="flip-left" src={bannermobile} alt='Image not found' />
            </ContanierMobile>
          </ContanierHead>

          <ContanierMainMobile>
            <ContMobImage src={contimgaemobile} alt='Image Not Found' />



            <CreationMain>
              <ImageTappTAG>
                <ContMobImage1 data-aos="flip-left" src={contimageup} alt='Image Not Found' />
              </ImageTappTAG>

              <AllContanier>


                <CreationHead data-aos="fade-right">Arm Home Workout Fitness<br></br> App</CreationHead>
                <MobileHeading data-aos="fade-right">Our Latest Creations</MobileHeading>
                <CreationPara expanded={expanded}>Welcome to Arm Scultor, the ultimate arm-
                  focused fitness app designed to help you build strength and definition in every
                  part of your arms.<br></br> Whether you're aiming for powerful shoulders,
                  bulging biceps, or toned triceps, our targeted workouts cater to your specific arm goals.</CreationPara>
                <CreationButton data-aos="fade-right" onClick={toggleReadMore}>{expanded ? 'Read Less' : 'Read More'}</CreationButton>
              </AllContanier>
            </CreationMain>


          </ContanierMainMobile>

          <Container19>

            <HeaderWeb data-aos="fade-right">Our Process</HeaderWeb>

            <Div3>


              <CardContainer>
                {cards.map((card, index) => (
                  <Card
                    data-aos="flip-left"
                    data-aos-easing="ease-out-cubic"
                    data-aos-duration="2000"
                    key={index}>
                    <CardImage src={card.img} alt={card.title} />
                    <CardTitle>{card.title}</CardTitle>
                    <CardDescription>{card.description}</CardDescription>
                  </Card>
                ))}
              </CardContainer>

            </Div3>
          </Container19>

          <Container20>
            <HeaderWeb data-aos="fade-right">Kicktart your Project with Big Heap Tech Reliable App <br></br> Development Process</HeaderWeb>
            <PeraWeb data-aos="fade-right">Big your project journey with Big Heap Tech trusted App Development process. We follow a
              straightforward <br></br> procedure to ensure efficent progress </PeraWeb>

            <ImageUiUx src={imageuiux} alt='NOT FOUND' />
          </Container20>

          <Container21>

            <HeaderWeb > APP Development Tools and Technologies</HeaderWeb>
            <PeraWeb >With our top technologies, your seccess is guaranteed  </PeraWeb>

            <TabNavigation>
              <Dflex>
                <FlexFill
                  onClick={() => updateToggle(1)}
                  active={toggle === 1}
                >
                  Tools
                </FlexFill>
                <FlexFill
                  onClick={() => updateToggle(2)}
                  active={toggle === 2}
                >
                  Technologies
                </FlexFill>

              </Dflex>

              <TabContents show={toggle === 1}>
                <Div2>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle111} alt='Image Not fOUND' />
                   
                  </CardTools1 >
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle112} alt='Image Not fOUND' />
                    
                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle113} alt='Image Not fOUND' />
                    
                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle114} alt='Image Not fOUND' />
                    
                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle115} alt='Image Not fOUND' />
                    
                  </CardTools1>



                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle116} alt='Image Not fOUND' />
                    
                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle117} alt='Image Not fOUND' />
                    
                  </CardTools1 >
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle118} alt='Image Not fOUND' />
                    
                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle119} alt='Image Not fOUND' />
                    
                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle121} alt='Image Not fOUND' />
                    
                  </CardTools1>
                </Div2>



              </TabContents>

              <TabContents show={toggle === 2}>
                <Div2>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle001} alt='Image Not fOUND' />

                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle002} alt='Image Not fOUND' />

                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle003} alt='Image Not fOUND' />

                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage src={Rectangle004} alt='Image Not fOUND' />

                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle005} alt='Image Not fOUND' />

                  </CardTools1>

               
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle006} alt='Image Not fOUND' />

                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle007} alt='Image Not fOUND' />

                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle008} alt='Image Not fOUND' />

                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle009} alt='Image Not fOUND' />

                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle010} alt='Image Not fOUND' />

                  </CardTools1>

                </Div2>
              </TabContents>








            </TabNavigation>
          </Container21>


        </MainWrapContanier>
      </Wrap>
    </>
  )
}

export default MobileAppDev
